export default {
  headers: {
    "content-type": "multipart/form-data",
    "Accept": "application/json",
  },
};
